export default __webpack_public_path__ + "static/media/icon-coin-ton.78de04a0.svg";